/* eslint-disable react/jsx-no-useless-fragment */
import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';
import RouteUrlPaths from '../../RouteUrlPaths';
import ManageUserAccessStore from '../../stores/ManageUserAccessStore';

interface ProtectedBizzesAndLicensePlatesRouteProps {
  manageUserAccessStore: ManageUserAccessStore;
}

const ProtectedBizzesAndLicensePlatesRoute: FC<ProtectedBizzesAndLicensePlatesRouteProps> = (
  props
) => {
  const { manageUserAccessStore, children } = props;
  if (!manageUserAccessStore.isPrivateCustomer()) {
    return <Navigate to={RouteUrlPaths.Frontpage} />;
  }
  return <>{children}</>;
};

export default ProtectedBizzesAndLicensePlatesRoute;
